import React from 'react';
import { Flex } from 'rebass';

interface TabListProps {}

export const TabList: React.FC<TabListProps> = ({ children }) => (
  <Flex tx="tabs" variant="tabList">
    {children}
  </Flex>
);
